<template>
    <div class="accordion-search">
        <form class="accordion-search__form">
            <input class="accordion-search__input" placeholder="Type in a key word to search..."
                list="accordion-search__datalist" v-model="search" />
            <datalist id="accordion-search__datalist">
                <option v-for="title in titles" :value="title" />
            </datalist>
            <button type="submit wp-block-button__link wp-element-button" class="accordion-search__submit"
                @click.prevent="searchAccordion">
                <img :src="`${themeDir}/images/icons/search.svg`" alt="Search" class="home-search__submit-icon" />
            </button>
        </form>
    </div>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue';
import { themeDir } from '@utils/theme';

// The titles of all of the accordions on the page
const titles = ref([]);

// The search term
const search = ref(null);

onMounted(() => {
    // Get all of the accordion titles and index them into the titles array so
    // we can use them for the datalist (autocomplete)
    const accordionTitles = document.querySelectorAll('.wp-block-getwid-accordion__header-title');
    accordionTitles.forEach(title => {
        titles.value.push(title.textContent);
    });
});

/**
 * Normalise text for searching; lower case, trim and remove any
 * non-alphanumeric characters
 */
const normaliseText = (text) => {
    return text.toLowerCase().trim().replace(/[^a-z0-9]/g, '');
};

/**
 * Search the accordion(s) for the search term
 */
const searchAccordion = () => {
    // If the search term is empty, don't do anything
    if (!search.value) {
        return;
    }
    // Loop through all of the accordion titles and see if the search term is in any of them
    const accordionTitles = document.querySelectorAll('.wp-block-getwid-accordion__header-title');
    for (let i = 0; i < accordionTitles.length; i++) {
        if (normaliseText(accordionTitles[i].textContent).includes(normaliseText(search.value))) {
            // If we find a match, open the accordion (if it's closed) and scroll to it
            const header = accordionTitles[i].closest('.wp-block-getwid-accordion__header');
            if (header.parentElement.classList.contains('ui-accordion-header-collapsed')) {
                setTimeout(() => {
                    header.children[0].click();
                }, 250);
            }
            header.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
        }
    }
};
</script>